var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("formattedDate")(_vm.item.commentedAt)))]),_c('td',[_vm._v(_vm._s(_vm.item.fullName))]),_c('td',[_vm._v(_vm._s(_vm.item.comment))]),_c('td',[_vm._v(_vm._s(_vm.item.rating))])])}
var staticRenderFns = []

export { render, staticRenderFns }